(() => {
  'use strict';

  const COOL_VARIANT_ID = 67602596790308;
  const STATUS_SECTION = 'espoa-cool-status';
  const SOURCE = 'espoa-cool-shipping';
  const OPTIONAL_ATTRIBUTE = '任意クール便';

  let syncing = false;
  let syncAgain = false;

  async function getCart() {
    const response = await fetch(`${window.routes.cart_url}.js`, {
      headers: {
        Accept: 'application/json',
      },
      cache: 'no-store',
    });

    if (!response.ok) {
      throw new Error(`Cart fetch failed: ${response.status}`);
    }

    return response.json();
  }

  async function getCoolStatus() {
    const separator = window.location.search ? '&' : '?';

    const url =
      `${window.location.pathname}${window.location.search}` +
      `${separator}section_id=${STATUS_SECTION}&_=${Date.now()}`;

    const response = await fetch(url, {
      headers: {
        Accept: 'text/html',
      },
      cache: 'no-store',
    });

    if (!response.ok) {
      throw new Error(`Cool status fetch failed: ${response.status}`);
    }

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const status = doc.querySelector('#EspoaCoolStatus');

    if (!status) {
      throw new Error('EspoaCoolStatus not found');
    }

    return {
      required: status.dataset.required === 'true',
      month: Number(status.dataset.month),
    };
  }

  async function addCoolCharge() {
    const response = await fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: COOL_VARIANT_ID,
            quantity: 1,
          },
        ],
      }),
    });

    if (!response.ok) {
      throw new Error(`Cool charge add failed: ${response.status}`);
    }

    return response.json();
  }

  async function setCoolChargeQuantity(lineKey, quantity) {
    const response = await fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: lineKey,
        quantity,
      }),
    });

    if (!response.ok) {
      throw new Error(`Cool charge change failed: ${response.status}`);
    }

    return response.json();
  }

  async function setOptionalCool(enabled) {
    const response = await fetch(window.routes.cart_update_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          [OPTIONAL_ATTRIBUTE]: enabled ? '希望する' : '',
        },
      }),
    });

    if (!response.ok) {
      throw new Error(`Optional cool update failed: ${response.status}`);
    }

    return response.json();
  }

  async function notifyDawn() {
    if (
      typeof publish === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined'
    ) {
      await publish(PUB_SUB_EVENTS.cartUpdate, {
        source: SOURCE,
      });
    }
  }

  function updateCheckbox(cart, required) {
    const checkbox = document.querySelector('#EspoaOptionalCool');
    const message = document.querySelector('#EspoaCoolMessage');

    if (!checkbox) return;

    const optional =
      cart.attributes?.[OPTIONAL_ATTRIBUTE] === '希望する';

    checkbox.checked = required || optional;
    checkbox.disabled = required;

    const text = checkbox.closest('label')?.querySelector('span');

    if (required) {
      if (text) {
        text.textContent = 'クール便（必須・＋330円）';
      }

      if (message) {
        message.textContent =
          'クール便対象商品が含まれているため、クール便料金330円が必要です。';
      }
    } else {
      if (text) {
        text.textContent = 'クール便を希望する（＋330円）';
      }

      if (message) {
        message.textContent =
          '通常便の商品もクール便でお届けできます。';
      }
    }
  }

  async function syncCoolCharge() {
    if (syncing) {
      syncAgain = true;
      return;
    }

    syncing = true;

    try {
      const [cart, status] = await Promise.all([
        getCart(),
        getCoolStatus(),
      ]);

      const optional =
        cart.attributes?.[OPTIONAL_ATTRIBUTE] === '希望する';

      const coolNeeded = status.required || optional;

      const coolLines = cart.items.filter(
        (item) => Number(item.variant_id) === COOL_VARIANT_ID
      );

      const coolQuantity = coolLines.reduce(
        (total, item) => total + item.quantity,
        0
      );

      let changed = false;

      // 必須または任意クールなのに料金がない
      if (coolNeeded && coolQuantity === 0) {
        await addCoolCharge();
        changed = true;

        if (status.required) {
          setTimeout(() => {
            const message =
              document.querySelector('#EspoaCoolMessage');

            if (message) {
              message.textContent =
                'クール便必須商品が含まれているため、クール便料金330円を再追加しました。';
            }
          }, 300);
        }
      }

      // クール便不要なのに料金が残っている
      if (!coolNeeded && coolQuantity > 0) {
        for (const line of coolLines) {
          await setCoolChargeQuantity(line.key, 0);
        }

        changed = true;
      }

      // クール便料金が2個以上なら1個に戻す
      if (coolNeeded && coolQuantity > 1) {
        let first = true;

        for (const line of coolLines) {
          if (first) {
            await setCoolChargeQuantity(line.key, 1);
            first = false;
          } else {
            await setCoolChargeQuantity(line.key, 0);
          }
        }

        changed = true;
      }

      updateCheckbox(cart, status.required);

      console.log('[ESPOA COOL]', {
        required: status.required,
        optional,
        coolNeeded,
        coolQuantity,
        changed,
      });

      if (changed) {
        await notifyDawn();
      }
    } catch (error) {
      console.error('[ESPOA COOL] sync failed', error);
    } finally {
      syncing = false;

      if (syncAgain) {
        syncAgain = false;
        setTimeout(syncCoolCharge, 100);
      }
    }
  }

  // 任意クール料金のゴミ箱を押した場合
  // 必須商品がなければ、任意クール希望もOFFにする
  document.addEventListener(
    'click',
    async (event) => {
      const removeButton =
        event.target.closest('cart-remove-button a');

      if (!removeButton) return;

      const cartItem = removeButton.closest('.cart-item');
      if (!cartItem) return;

      const nameElement =
        cartItem.querySelector('.cart-item__name');

      const itemName =
        nameElement?.textContent?.trim();

      if (itemName !== 'クール便料金') return;

      try {
        const [cart, status] = await Promise.all([
          getCart(),
          getCoolStatus(),
        ]);

        const optional =
          cart.attributes?.[OPTIONAL_ATTRIBUTE] === '希望する';

        if (!status.required && optional) {
          await setOptionalCool(false);

          const checkbox =
            document.querySelector('#EspoaOptionalCool');

          if (checkbox) {
            checkbox.checked = false;
          }
        }
      } catch (error) {
        console.error(
          '[ESPOA COOL] remove handling failed',
          error
        );
      }
    },
    true
  );

  // 任意クールのチェックON/OFF
  document.addEventListener('change', async (event) => {
    if (event.target.id !== 'EspoaOptionalCool') return;

    const checkbox = event.target;

    try {
      checkbox.disabled = true;

      await setOptionalCool(checkbox.checked);
      await syncCoolCharge();
      await notifyDawn();
    } catch (error) {
      console.error(
        '[ESPOA COOL] optional change failed',
        error
      );
    } finally {
      checkbox.disabled = false;
    }
  });

  // 初回読み込み＋Dawnのカート更新を監視
  document.addEventListener('DOMContentLoaded', () => {
    syncCoolCharge();

    if (
      typeof subscribe === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined'
    ) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event?.source === SOURCE) return;

        setTimeout(syncCoolCharge, 150);
      });
    }
  });
})();